import CoreSelect from '@/components/Form/SelectAntForm';
import { useCoreContext } from '@/core';
import { get } from 'lodash';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface Props {
  className?: string;
}

export const BusinessUnitChildrenPicker = (props: Props) => {
  const { className } = props;
  const { t } = useTranslation();
  const { control } = useFormContext();
  const { businessUnitList } = useCoreContext();
  const [currentQueryParameters] = useSearchParams();
  const showId = currentQueryParameters.get('id');

  const businessUnitNoParentList = (businessUnitList ?? []).filter((unit: { parentId?: string | null; id?: string }) => {
    if (showId && unit.id === showId) {
      return false;
    }
    return unit.parentId == null || unit.parentId === showId;
  });

  return (
    <CoreSelect
      control={control}
      name='childrenIds'
      label={t('common.businessUnitChildren')}
      mode='multiple'
      optionsProps={businessUnitNoParentList}
      displayField='name'
      valueField='id'
      className={className}
      filterOption={(inputValue, option) => {
        if (option) {
          return String(get(option, 'label')).toLowerCase().includes(inputValue.toLowerCase());
        }
        return true;
      }}
    />
  );
};
